import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Packet 005 — Global navigation viewport rule (single source of truth).
// On any route/location change, the destination opens at its intended
// beginning/top so the user never has to manually scroll upward. When a
// location hash targets a section, that section is positioned at the top
// instead, preserving explicitly targeted section behavior.
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const target = document.getElementById(hash.slice(1));
      if (target) {
        target.scrollIntoView({ block: "start" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
